import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class EnergyEfficiencyAndGreenDetail {
    constructor(doc)
    {
		this.label = null;
		this.efficiencyRatingExistsIndicator = null;
		this.energyEfficientAndGreenDescription = null;
		this.greenCertificationExistsIndicator = null;
		this.renewableEnergyComponentExistsIndicator = null;
		this.valueMarketabilityImpactType = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.efficiencyRatingExistsIndicator = x.getBooleanElement(doc, "./ns:EfficiencyRatingExistsIndicator");
		this.energyEfficientAndGreenDescription = x.getStringElement(doc, "./ns:EnergyEfficientAndGreenDescription");
		this.greenCertificationExistsIndicator = x.getBooleanElement(doc, "./ns:GreenCertificationExistsIndicator");
		this.renewableEnergyComponentExistsIndicator = x.getBooleanElement(doc, "./ns:RenewableEnergyComponentExistsIndicator");
		this.valueMarketabilityImpactType = x.getStringElement(doc, "./ns:ValueMarketabilityImpactType");
   }
}

export class GreenBuildingCertification {
    constructor(doc)
    {
		this.label = null
		this.greenCertificationAssociationName = null
		this.greenCertificationLevelAwardedYear = null
		this.greenCertificationLevelName = null
		this.greenCertificationName = null
		this.greenCertificationVersionIdentifier = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.greenCertificationAssociationName = x.getStringElement(doc, "./ns:GreenCertificationAssociationName");
		this.greenCertificationLevelAwardedYear = x.getStringElement(doc, "./ns:GreenCertificationLevelAwardedYear");
		this.greenCertificationLevelName = x.getStringElement(doc, "./ns:GreenCertificationLevelName");
		this.greenCertificationName = x.getStringElement(doc, "./ns:GreenCertificationName");
		this.greenCertificationVersionIdentifier = x.getStringElement(doc, "./ns:GreenCertificationVersionIdentifier");
   }
}

export class GreenEfficiencyRating {
    constructor(doc)
    {
		this.label = null;
		this.efficiencyRatingName = null;
		this.efficiencyRatingOrganizationName = null;
		this.efficiencyRatingScoreValue = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.efficiencyRatingName = x.getStringElement(doc, "./ns:EfficiencyRatingName");
		this.efficiencyRatingOrganizationName = x.getStringElement(doc, "./ns:EfficiencyRatingOrganizationName");
		this.efficiencyRatingScoreValue = x.getStringElement(doc, "./ns:EfficiencyRatingScoreValue");
   }
}

export class RenewableEnergyComponent {
    constructor(doc)
    {
		this.label = null
		this.renewableEnergyComponentFinancedIndicator = null
		this.renewableEnergyComponentOwnershipType = null
		this.renewableEnergyComponentOwnershipTypeOtherDescription = null
		this.renewableEnergyComponentType = null
		this.renewableEnergyComponentTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.renewableEnergyComponentFinancedIndicator = x.getBooleanElement(doc, "./ns:RenewableEnergyComponentFinancedIndicator");
		this.renewableEnergyComponentOwnershipType = x.getStringElement(doc, "./ns:RenewableEnergyComponentOwnershipType");
		this.renewableEnergyComponentOwnershipTypeOtherDescription = x.getStringElement(doc, "./ns:RenewableEnergyComponentOwnershipTypeOtherDescription");
		this.renewableEnergyComponentType = x.getStringElement(doc, "./ns:RenewableEnergyComponentType");
		this.renewableEnergyComponentTypeOtherDescription = x.getStringElement(doc, "./ns:RenewableEnergyComponentTypeOtherDescription");
   }

	GetComponentType() {
		return h.descriptionOrOther(this.renewableEnergyComponentType, this.renewableEnergyComponentTypeOtherDescription);
	}
	GetOwnershipType() {
		return h.descriptionOrOther(this.renewableEnergyComponentOwnershipType, this.renewableEnergyComponentOwnershipTypeOtherDescription);
	}
	GetFinancing() {
		if (this.renewableEnergyComponentOwnershipType === "Owned")
				return h.yesNo(this.renewableEnergyComponentFinancedIndicator);
		return "";
	}

}

export class EnergyEfficiencyAndGreen {
    constructor(doc)
    {
		this.label = null
		this.energyEfficiencyAndGreenDetail = null
		this.greenBuildingCertifications = []
		this.greenEfficiencyRatings = []
		this.renewableEnergyComponents = []
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:ENERGY_EFFICIENCY_AND_GREEN_DETAIL");
		if (node !== null)
				this.energyEfficiencyAndGreenDetail = new EnergyEfficiencyAndGreenDetail(node);
		nodes = x.selectNodes(doc, "./ns:GREEN_BUILDING_CERTIFICATIONS/ns:GREEN_BUILDING_CERTIFICATION");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.greenBuildingCertifications.push(new GreenBuildingCertification(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:GREEN_EFFICIENCY_RATINGS/ns:GREEN_EFFICIENCY_RATING");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.greenEfficiencyRatings.push(new GreenEfficiencyRating(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:RENEWABLE_ENERGY_COMPONENTS/ns:RENEWABLE_ENERGY_COMPONENT");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.renewableEnergyComponents.push(new RenewableEnergyComponent(xn));
			});
		}
   }

	EnergyExists() {
		if (this.energyEfficiencyAndGreenDetail.efficiencyRatingExistsIndicator ?? false) return true;
		if (this.energyEfficiencyAndGreenDetail.greenCertificationExistsIndicator ?? false) return true;
		if (this.energyEfficiencyAndGreenDetail.renewableEnergyComponentExistsIndicator ?? false) return true;
		return false;
	}

	GetRenewableEnergyComponentExists() {
		let eegd  = global.ptr.subProp.energyEfficiencyAndGreen.energyEfficiencyAndGreenDetail;
		let bRECE = eegd.renewableEnergyComponentExistsIndicator ?? false;
		return bRECE;
	}

	GetEfficiencyRatingExists() {
		let eegd  = global.ptr.subProp.energyEfficiencyAndGreen.energyEfficiencyAndGreenDetail;
		let bERE  = eegd.efficiencyRatingExistsIndicator ?? false;
		return bERE; // this to cause no display
	}

	GetGreenCertificationExists() {
		let eegd  = global.ptr.subProp.energyEfficiencyAndGreen.energyEfficiencyAndGreenDetail;
		let bGCE = eegd.greenCertificationExistsIndicator ?? false;
		return bGCE;
	}

	GetRating() {
		let rating = "";
		if (this.greenEfficiencyRatings === null) return "None";
		for (const r of this.greenEfficiencyRatings) {
			rating = h.addWithNewline(rating, r.efficiencyRatingName);
			rating = h.addWithSpacer(rating, r.efficiencyRatingScoreValue.toString());
		}
		return rating;
	}

	GetCertifications() {
		let certs = "";
		if (this.greenBuildingCertifications === null) return "None";
		for (const c of this.greenBuildingCertifications) {
			certs = h.addWithNewline(certs, c.greenCertificationName);
			certs = h.addWithSpace(certs, c.greenCertificationLevelName);
		}
		return certs;
	}

	GetEnergyComponents() {
		let certs = "";
		if (!(this.energyEfficiencyAndGreenDetail.renewableEnergyComponentExistsIndicator ?? false)) return "None";
		if (this.renewableEnergyComponents === null) return "None";
		for (const rec of this.renewableEnergyComponents) {
			certs = h.addWithSpacer(certs, rec.GetComponentType());
		}
		return certs;
	}

}
